import { useCherreValue } from './useCherreValue';
import { useCherreSetState } from './useCherreSetState';
import { CherreState } from '../recoil';

export const useCherreState = <T>(node: CherreState<T>) => {
  const value = useCherreValue(node);
  const setter = useCherreSetState(node);
  return [value, setter] as const;
};
